import type { SvgIconProps } from "@mui/material";
import { SvgIcon } from "@mui/material";
import type { FunctionComponent } from "react";

export const CopyIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M12 2.5H10.4375C10.1875 1.375 9.1875 0.5 8 0.5C6.78125 0.5 5.78125 1.375 5.53125 2.5H4C2.875 2.5 2 3.40625 2 4.5V14.5C2 15.625 2.875 16.5 4 16.5H12C13.0938 16.5 14 15.625 14 14.5V4.5C14 3.40625 13.0938 2.5 12 2.5ZM8 2C8.40625 2 8.75 2.34375 8.75 2.75C8.75 3.1875 8.40625 3.5 8 3.5C7.5625 3.5 7.25 3.1875 7.25 2.75C7.25 2.34375 7.5625 2 8 2ZM12.5 14.5C12.5 14.7812 12.25 15 12 15H4C3.71875 15 3.5 14.7812 3.5 14.5V4.5C3.5 4.25 3.71875 4 4 4H4.5625C4.5 4.1875 4.5 4.34375 4.5 4.5V5C4.5 5.28125 4.71875 5.5 5 5.5H11C11.25 5.5 11.5 5.28125 11.5 5V4.5C11.5 4.34375 11.4688 4.1875 11.4062 4H12C12.25 4 12.5 4.25 12.5 4.5V14.5Z"
        fill="#C1CFDE"
      />
    </SvgIcon>
  );
};
